<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <h3 class="page-header">Component Permission Users/Groups</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-lg-6">
      <b>Component:</b> &nbsp;
      <aims-lookup name="Component"
        style="width:50%"
        [gridText]="'Select a Component'"
        id="componentLookup"
        [values]="components | async"
        [idPropertyName]="'componentId'"
        [displayPropertyName]="'component'"
        [columnsInGrid]="componentLookupColumns"
        (valueChangeObj)="handleComponentLookupChange($event)"
        >
      </aims-lookup>
    </div>
  </div>

    <aims-common-table
        id="PermissionsReport"
        [dataSource]="componentsPGValues"
        [header]="componentsPGHeader"
        [permissions]="componentsPGPermissions"
        [stickyHeader]="true"
        [pageSize]="10"
    >
      <aims-common-table-dynamic-row id="type">
       <ng-template aimsHeaderTemplate let-formGroup="formGroup">
        <div
          matTooltipClass="matToolTipMultiLine"
          matTooltipPosition="above"
          matTooltip="Permission Group or Employee">Type<i class="fas fa-question-circle"></i>
        </div>
      </ng-template>

        <ng-template viewMode let-element let-dynamicControl="dynamicControl">
          <div *ngIf="element.permissionGroupName">
            <mat-icon>group</mat-icon>
          </div>
          <div *ngIf="element.fullName">
            <mat-icon>person</mat-icon>
          </div>
        </ng-template>
      </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="permissionUserOrPgName">
          <ng-template viewMode let-element let-dynamicControl="dynamicControl">
            <div *ngIf="element.permissionGroupName">
              {{ element.permissionGroupName}}
            </div>
            <div *ngIf="element.fullName">
              {{ element.fullName }}
            </div>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="create">
          <ng-template viewMode let-element let-dynamicControl="dynamicControl">
            <div class="text-center">
              <ng-container *ngIf="element.create === true">
                <img src="{{imgSrc}}/check.png" style="width:20px" />
              </ng-container>
              <ng-container *ngIf="!element.create">
                <img src="{{imgSrc}}/X.png" style="width:20px" />
              </ng-container>
            </div>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="read">
          <ng-template viewMode let-element let-dynamicControl="dynamicControl">
              <div class="fullWidth text-center">
                <ng-container *ngIf="element.read">
                  <img src="{{imgSrc}}/check.png" style="width:20px" />
                </ng-container>
                <ng-container *ngIf="!element.read">
                  <img src="{{imgSrc}}/X.png" style="width:20px" />
                </ng-container>
              </div>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="update">
          <ng-template viewMode let-element let-dynamicControl="dynamicControl">
            <div class="fullWidth text-center">
              <ng-container *ngIf="element.update">
                <img src="{{imgSrc}}/check.png" style="width:20px" />
              </ng-container>
              <ng-container *ngIf="!element.update">
                <img src="{{imgSrc}}/X.png" style="width:20px" />
              </ng-container>
            </div>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="delete">
          <ng-template viewMode let-element let-dynamicControl="dynamicControl">
            <div class="fullWidth text-center">
              <ng-container *ngIf="element.delete">
                <img src="{{imgSrc}}/check.png" style="width:20px" />
              </ng-container>
              <ng-container *ngIf="!element.delete">
                <img src="{{imgSrc}}/X.png" style="width:20px" />
              </ng-container>
            </div>
          </ng-template>
        </aims-common-table-dynamic-row>
    </aims-common-table>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
